<!-- Header con gradiente -->
<div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 20px 24px; border-bottom: 2px solid #bbf7d0;">
  <div class="flex items-center gap-3">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">note_add</mat-icon>
    <div>
      <h2 style="margin: 0; font-size: 1.25rem; font-weight: 800; color: #1e5a3f;">
        Crear Transacción Manual
      </h2>
      <span class="text-xs" style="color: #6b7280;">Usuario: {{ data.nombre }}</span>
    </div>
  </div>
</div>

<!-- Body -->
<div style="padding: 24px;">
  <form [formGroup]="createForm" (ngSubmit)="onSubmit()" *ngIf="createForm">
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">

      <!-- Usuario ID -->
      <mat-form-field class="w-full modern-field" appearance="outline">
        <mat-label>Usuario Id</mat-label>
        <mat-icon matPrefix style="color: #6b7280;">person</mat-icon>
        <input matInput formControlName="usuarioId"/>
      </mat-form-field>

      <!-- Total Destino -->
      <mat-form-field class="w-full modern-field" appearance="outline">
        <mat-label>Total Destino</mat-label>
        <mat-icon matPrefix style="color: #6b7280;">payments</mat-icon>
        <input matInput formControlName="totalDest" appOnlynumber placeholder="Total Destino"/>
      </mat-form-field>

      <!-- Tasa -->
      <div>
        <mat-form-field class="w-full modern-field" appearance="outline">
          <mat-label>Tasa</mat-label>
          <mat-icon matPrefix style="color: #6b7280;">trending_up</mat-icon>
          <input matInput formControlName="tasa" appOnlynumber placeholder="Tasa" (change)="loadDestinoOnTasaChange()" required/>
        </mat-form-field>
        <div *ngIf="createForm.get('tasa')?.touched && createForm.get('tasa')?.errors?.['minValue']"
          style="display: flex; align-items: center; gap: 6px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; padding: 6px 12px; margin-top: -8px; margin-bottom: 8px;">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #dc2626;">error</mat-icon>
          <span style="font-size: 0.75rem; color: #dc2626; font-weight: 600;">
            La tasa no puede ser inferior a
            <span class="font-bold">{{ precioSpot && factorManual ? (+precioSpot + +factorManual) : 0 }}</span>
          </span>
        </div>
      </div>

      <!-- Moneda Destino -->
      <mat-form-field class="w-full modern-field" appearance="outline">
        <mat-label>Moneda Destino</mat-label>
        <mat-icon matPrefix style="color: #6b7280;">currency_exchange</mat-icon>
        <mat-select required formControlName="monedaDestino">
          <mat-option>Seleccione una moneda</mat-option>
          <mat-option *ngFor="let filter of filters" [value]="filter">
            {{ selectedCurren[filter] }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Moneda Local -->
      <mat-form-field class="w-full modern-field" appearance="outline">
        <mat-label>Moneda Local</mat-label>
        <mat-icon matPrefix style="color: #6b7280;">attach_money</mat-icon>
        <mat-select required formControlName="monedaLocal">
          <mat-option>Seleccione una moneda</mat-option>
          <mat-option *ngFor="let filter of filtersLocal" [value]="filter">
            {{ selectedCurren[filter] }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Monto Promesa -->
      <mat-form-field class="w-full modern-field" appearance="outline">
        <mat-label>Monto Promesa</mat-label>
        <mat-icon matPrefix style="color: #6b7280;">savings</mat-icon>
        <input matInputCommified matInput formControlName="totalEnvio" placeholder="Monto Promesa" appOnlynumber (change)="loadDestino()"/>
      </mat-form-field>

      <!-- Wallet TRX (full width) -->
      <div class="sm:col-span-2">
        <mat-form-field class="w-full modern-field" appearance="outline">
          <mat-label>Wallet TRX</mat-label>
          <mat-icon matPrefix style="color: #6b7280;">account_balance_wallet</mat-icon>
          <input matInput formControlName="walletTrx" placeholder="Wallet TRX" required/>
        </mat-form-field>

        <!-- Validando -->
        <div *ngIf="walletValidating"
          style="display: flex; align-items: center; gap: 8px; padding: 8px 12px; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 8px; margin-bottom: 8px;">
          <mat-spinner diameter="16"></mat-spinner>
          <span style="font-size: 0.78rem; color: #2563eb; font-weight: 600;">Validando wallet...</span>
        </div>

        <!-- Match: beneficiario encontrado -->
        <div *ngIf="!walletValidating && walletValidated && walletBeneficiario"
          style="display: flex; align-items: center; gap: 8px; padding: 8px 12px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 8px; margin-bottom: 8px;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #16a34a; flex-shrink: 0;">check_circle</mat-icon>
          <span style="font-size: 0.78rem; color: #166534; font-weight: 600;">Beneficiario: {{ walletBeneficiario }}</span>
        </div>

        <!-- No match: wallet no encontrada -->
        <div *ngIf="!walletValidating && walletError"
          style="display: flex; align-items: center; gap: 8px; padding: 8px 12px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; margin-bottom: 8px;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; flex-shrink: 0;">error</mat-icon>
          <span style="font-size: 0.78rem; color: #dc2626; font-weight: 600;">{{ walletError }}</span>
        </div>
      </div>
    </div>

    <!-- Botones -->
    <div class="flex justify-end gap-3 mt-4 pt-4" style="border-top: 1px solid #e5e7eb;">
      <button type="button" (click)="closeDialog()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'"
        onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #374151;">close</mat-icon>
        Cancelar
      </button>
      <button type="submit" [disabled]="isSubmitDisabled"
        [style.opacity]="isSubmitDisabled ? '0.5' : '1'"
        [style.cursor]="isSubmitDisabled ? 'not-allowed' : 'pointer'"
        style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="if(!this.disabled)this.style.background='#059669'"
        onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">check_circle</mat-icon>
        Crear transacción
      </button>
    </div>
  </form>
</div>
